import z from 'zod';

import {
    CURRENT_VERSION,
    ElementId,
    EmptyChildren,
    emptyChildren,
    UnityElementId,
    Version,
} from '../commons';
import { ELEMENT_TYPES } from '../constants';

export const UnityCustomJson = z.object({
    type: z.literal(ELEMENT_TYPES.CUSTOM_JSON),
    elementId: UnityElementId,
    templateElement: z.boolean().optional(),
    version: Version,
    data: z.string(),
});
export type UnityCustomJson = z.infer<typeof UnityCustomJson>;

export const PlateCustomJson = z.object({
    type: z.literal(ELEMENT_TYPES.CUSTOM_JSON),
    id: ElementId,
    data: z.object({
        templateElement: z.boolean().optional(),
        json: z.string(),
    }),
    children: EmptyChildren,
});
export type CustomJsonElement = z.infer<typeof PlateCustomJson>;

export const CustomJsonCodec = z.codec(UnityCustomJson, PlateCustomJson, {
    decode: (value) => ({
        type: value.type,
        id: value.elementId ?? crypto.randomUUID(),
        data: {
            ...(value.templateElement ? { templateElement: value.templateElement } : {}),
            json: value.data,
        },
        children: emptyChildren,
    }),

    encode: (value) => ({
        type: value.type,
        elementId: value.id,
        version: CURRENT_VERSION,
        ...(value.data.templateElement ? { templateElement: value.data.templateElement } : {}),
        data: value.data.json,
    }),
});
